<!-- page Header -->
<section class="lead-hero curve -bottom -white">
  <span class="photo"></span>
  <div class="intro">
    <div class="container">
      <!-- click back -->
      <div class="flow">
        <a [routerLink]="['/fund']">
          <i class="icon icon-arrow-back"></i>
          <span class="text">{{language.backfund}}</span>
        </a>
      </div>

      <!-- header title -->
      <div class="row no-gutter">
        <div class="col-xl-7">
          <h1 class="title">{{fundNameEn}} {{fundCode}}</h1>
          <section class="risk-detail">
            <ul class="list list-unstyled list-inline">
              <li>
                <span class="group">
                  <span class="thumb">
                    <img *ngIf="riskSpectrum === '1'" src="../../../assets/images/risk/level-1@2x.png"
                      class="img-responsive" alt="level 1">
                    <img *ngIf="riskSpectrum === '2'" src="../../../assets/images/risk/level-2@2x.png"
                      class="img-responsive" alt="level 2">
                    <img *ngIf="riskSpectrum === '3'" src="../../../assets/images/risk/level-3@2x.png"
                      class="img-responsive" alt="level 3">
                    <img *ngIf="riskSpectrum === '4'" src="../../../assets/images/risk/level-4@2x.png"
                      class="img-responsive" alt="level 4">
                    <img *ngIf="riskSpectrum === '5'" src="../../../assets/images/risk/level-5@2x.png"
                      class="img-responsive" alt="level 5">
                    <img *ngIf="riskSpectrum === '6'" src="../../../assets/images/risk/level-6@2x.png"
                      class="img-responsive" alt="level 6">
                    <img *ngIf="riskSpectrum === '7'" src="../../../assets/images/risk/level-7@2x.png"
                      class="img-responsive" alt="level 7">
                    <ng-container *ngIf="fundCode != 'GAHREIT'">
                      <img *ngIf="riskSpectrum === '8'" src="../../../assets/images/risk/level-8@2x.png"
                        class="img-responsive" alt="level 8">
                    </ng-container>
                    <img *ngIf="riskSpectrum === '8+'" src="../../../assets/images/risk/level-8plus@2x.png" class="img-responsive"
                      alt="level 8+">
                  </span>
                  <ng-container *ngIf="(fundCode != 'GAHREIT') && (riskSpectrum !== '8')">
                    <span class="text">{{riskSpectrumName}}
                      <br>
                    </span>
                  </ng-container>
                </span>
              </li>
              <li *ngIf="IsFlagMorning == 'y' ">
                <span class="group -morning">
                  <span class="thumb"></span>
                  <span class="text">
                    {{MorningStarLevel}} {{language.funddetailthmorning1}}
                    <time>{{language.funddetailthmorning2}} {{MorningStarDate}} </time>
                  </span>
                </span>
              </li>
            </ul>
          </section>
        </div>
        <div class="col-xl-5 text-right -lg">
          <ul class="list-unstyled list-inline list-feature">
            <li>
              <app-favorite-button [fundid]="FunbId" [curr]="currency" [inCard]="false"></app-favorite-button>
            </li>
            <li>
              <a [routerLink]="['/fund/compare']" routerLinkActive="router-link-active"
                class="btn btn-primary -bg-white">{{language.funddetailthheaderbtn1}}</a>
            </li>
            <li>
              <a href="https://onelive.one-asset.com/Home" target="_blank" class="btn btn-primary -brand -short">
                <i class="icon icon-cart"></i>
                {{language.funddetailthheaderbtn2}}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- page Header -->
<!-- page Content -->
<section class="content-inner">

  <div class="container">
    <section class="section-select -menu d-block d-lg-none">
      <app-dropdown [title]="tabtitle" [valueDropdown]="usdvalueDropdown" (selected)="selectValue($event)">
      </app-dropdown>
    </section>
    <div class="tab-listing d-none d-lg-block">
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a class="nav-link active" id="one-tab" data-toggle="tab" href="#one" role="tab" aria-controls="one"
            aria-selected="true" (click)="selectValue(1)">
            {{language.funddetailthmenu1}}
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link " id="two-tab" data-toggle="tab" href="#two" role="tab" aria-controls="two"
            aria-selected="false" (click)="selectValue(2)">
            {{language.funddetailthmenu2}}
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link " id="three-tab" data-toggle="tab" href="#three" role="tab" aria-controls="three"
            aria-selected="false" (click)="selectValue(3)">
            {{language.funddetailthmenu11}}
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link " id="four-tab" data-toggle="tab" href="#four" role="tab" aria-controls="four"
            aria-selected="false" (click)="selectValue(4)">
            {{language.funddetailthmenu12}}
          </a>
        </li>
      </ul>
    </div>
  </div>

  <div class="tab-content" id="myTabContent">
    <div [ngSwitch]="choiceFromSelect">

      <div *ngSwitchCase="'detail'" class="tab-pane fade show active" id="one" role="tabpanel"
        aria-labelledby="one-tab">
        <section class="fund-detail">
          <div class="container">
            <div class="row">
              <div class="col-lg-6 col-xl-5">
                <section class="info">
                  <section class="wrapper">
                    <header>
                      <h2 class="topic-title">
                        <span rel="border-circle">
                          <i class="icon icon-price"></i>
                        </span>
                        <span class="text">
                          {{language.funddetailthmenu13}}
                          <span class="day">{{language.funddetailthmenu14}} {{fundDate}}</span>
                        </span>
                      </h2>
                    </header>
                    <section class="widget -stock">
                      <div class="value">
                        <span class="number">{{navPublish | number : '1.4-4'}}</span>
                        <span class="index {{isPositive(navDiff) ? 'up' : 'down'}}">
                          <i [ngClass]="(isPositive(navDiff))?'icon icon-arrow-index':'icon icon-arrow-index-down'"></i>
                          <span>
                            {{showOnlyValue(navDiff)}}
                            <small>({{showOnlyValue(navDiffPercentage)}}%)</small>
                          </span>
                        </span>
                      </div>
                    </section>
                    <ul class="list list-value list-unstyled">
                      <li>
                        <span class="text">{{language.funddetailthmenu15}}</span>
                        <span class="number text-right -sm">{{bid | number : '1.4-4'}}</span>
                      </li>
                      <li>
                        <span class="text">{{language.funddetailthmenu16}}</span>
                        <span class="number text-right -sm">{{offer | number : '1.4-4'}}</span>
                      </li>
                      <li>
                        <span class="text">{{language.funddetailthmenu17}}</span>
                        <span class="number text-right -sm">{{netAsset | number : '1.2-2'}}</span>
                      </li>
                    </ul>
                  </section>
                  <div class="group-section -devided">
                    <section>
                      <header>
                        <h2 class="topic-title">
                          <span rel="border-circle">
                            <i class="icon icon-devided"></i>
                          </span>
                          <span class="text">{{language.funddetailthmenu18}}</span>
                        </h2>
                      </header>
                      <p class="p-2">{{divenPolicy}}</p>
                    </section>
                  </div>
                </section>
              </div>
              <div class="col-lg-6 col-xl-7">
                <section class="info">
                  <header>
                    <h2 class="topic-title">
                      <span rel="border-circle">
                        <i class="icon icon-graph-stock"></i>
                      </span>
                      <span class="text">{{language.funddetailthmenu19}}</span>
                    </h2>
                  </header>
                  <div style="width: 100%;">
                    <!-- <canvas baseChart [chartType]="'line'" [datasets]="lineChartData" [labels]="chartLabels"
                            [colors]="chartColors" [options]="chartOptions" [legend]="true">
                          </canvas> -->
                    <div id="container" class="area-chart" [chart]="chart"></div>

                  </div>
                </section>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 col-xl-5">
                <section class="group-section">
                  <header>
                    <h2 class="topic-title">
                      <span rel="border-circle">
                        <i class="icon icon-trophy"></i>
                      </span>
                      <span class="text">{{language.funddetailthmenu20}}</span>
                    </h2>
                  </header>
                  <div class="widget -award">
                    <div class="photo" data-mh="award-photo">
                      <p>{{cms_reward}}</p>
                    </div>
                  </div>
                </section>
              </div>
              <div class="col-lg-6 col-xl-7">
                <section class="group-section">
                  <header>
                    <h2 class="topic-title">
                      <span rel="border-circle">
                        <i class="icon icon-goal"></i>
                      </span>
                      <span class="text">{{language.funddetailthmenu21}}</span>
                    </h2>
                  </header>
                  <div class="info">
                    <h3 class="h6 f-semibold topic-title">{{language.funddetailthmenu22}}</h3>
                    <p class="p-2">{{cms_investment_stype}}</p>
                  </div>
                  <div class="info">
                    <h3 class="h6 f-semibold topic-title">{{language.funddetailthmenu23}}</h3>
                    <p class="p-2">{{cms_investment_type}}</p>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>

        <section class="section-group -general curve -top">
          <div class="container">
            <header class="heading-title">
              <h2 class="topic-title">
                <span rel="border-circle">
                  <i class="icon icon-data"></i>
                </span>
                <span class="text">{{language.funddetailthmenu24}}</span>
              </h2>
            </header>
            <div class="row">
              <div class="col-md-12">
                <div class="info">
                  <h3 class="h6 topic-title">{{language.funddetailthmenu25}}</h3>
                  <P>{{typeName}}</P>
                </div>
              </div>
              <div class="col-md-12">
                <div class="info">
                  <h3 class="h6 topic-title">{{language.funddetailthmenu26}}</h3>
                  <div class="investment-policy" [innerHTML]="cms_investment_policy"></div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-6">
                <div class="row">
                  <div class="col-xs-12 col-sm-6">
                    <div class="info">
                      <h3 class="h6 topic-title">{{language.funddetailthmenu27}}</h3>
                      <p>{{fundCode}}</p>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6">
                    <div class="info">
                      <h3 class="h6 topic-title">{{language.funddetailthmenu28}}</h3>
                      <p>{{regName}}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-6">
                <div class="row">
                  <div class="col-xs-12 col-sm-6">
                    <div class="info">
                      <h3 class="h6 topic-title">{{language.funddetailthmenu29}}</h3>
                      <p>{{trusteeName}}</p>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6">
                    <div class="info">
                      <h3 class="h6 topic-title">{{language.funddetailthmenu30}}</h3>
                      <p>{{incepDate}}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-6">
                <div class="info non-margin">
                  <h3 class="h6 topic-title">{{language.funddetailthmenu31}}</h3>
                  <p>{{accountPeriod}}</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="curve -white -top -have-doc" style="margin-top: 0;">
          <section class="section-group -graph non-border">
            <div class="container">
              <section class="group-graph">
                <header class="heading-title">
                  <div class="row">
                    <div class="col-md-6">
                      <h2 class="topic-title">
                        <span rel="border-circle">
                          <i class="icon icon-port"></i>
                        </span>
                        <span class="text">{{language.funddetailthmenu32}}</span>
                      </h2>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-7">
                      <div class="group text-center">
                        <h4 class="subtitle">{{language.funddetailthmenu33}}</h4>
                        <div style="width: 100%;">
                          <div id="container" class="pie-chart" [chart]="donut_x"></div>

                        </div>
                      </div>
                    </div>
                    <div class="col-lg-5">
                      <section class="group-company">
                        <h4 class="sub-title text-center">{{language.funddetailthmenu34}}</h4>
                        <table class="table table--noborder -company">
                          <tbody>
                            <tr *ngFor="let item of top5Holding">
                              <th>{{item.Key}}</th>
                              <td>{{fixFloatDigit(item.Value)}}%</td>
                            </tr>
                          </tbody>
                        </table>
                      </section>
                    </div>
                  </div>
                </header>
              </section>
            </div>
          </section>
        </section>
      </div>

      <div *ngSwitchCase="'perf'" class="tab-pane fade show active" id="two" role="tabpanel" aria-labelledby="two-tab">
        <div class="container">
          <section class="section-group section-graph non-border" style="padding-bottom: 0 !important">
            <header>
              <h2 class="topic-title">
                <span rel="border-circle">
                  <i class="icon icon-graph-stock"></i>
                </span>
                <span class="text">Historical performance of the fund</span>
              </h2>
            </header>
            <div class="row">
              <div class="col-lg-12">
                <div style="width: 100%;">
                  <div id="container" [chart]="chart_line"></div>
                </div>
              </div>
            </div>
            <ul class="list-inline list-year text-center d-none d-sm-none d-md-block d-lg-block d-xl-block">
              <li>
                <a class="indexSelector" (click)="onSearchGraph(1)" [ngClass]="(index_v == 1)?'active':''">YTD</a>
              </li>
              <li>
                <a class="indexSelector" (click)="onSearchGraph(2)" [ngClass]="(index_v == 2)?'active':''">1M</a>
              </li>
              <li>
                <a class="indexSelector" (click)="onSearchGraph(3)" [ngClass]="(index_v == 3)?'active':''">3M</a>
              </li>
              <li>
                <a class="indexSelector" (click)="onSearchGraph(4)" [ngClass]="(index_v == 4)?'active':''">6M</a>
              </li>
              <li>
                <a class="indexSelector" (click)="onSearchGraph(5)" [ngClass]="(index_v == 5)?'active':''">1Y</a>
              </li>
              <li>
                <a class="indexSelector" (click)="onSearchGraph(6)" [ngClass]="(index_v == 6)?'active':''">3Y</a>
              </li>
              <li>
                <a class="indexSelector" (click)="onSearchGraph(7)" [ngClass]="(index_v == 7)?'active':''">5Y</a>
              </li>
              <li>
                <a class="indexSelector" (click)="onSearchGraph(8)" [ngClass]="(index_v == 8)?'active':''">10Y</a>
              </li>
              <li>
                <a class="indexSelector" (click)="onSearchGraph(9)" [ngClass]="(index_v == 9)?'active':''">Since
                  Inception</a>
              </li>
            </ul>
          </section>

          <section class="section-group section-table">
            <header style="margin-bottom: 20px">
              <div class="row">
                <div class="col-lg-12 col-xl-12">
                  <h2 class="topic-title">
                    <span rel="border-circle">
                      <i class="icon icon-data"></i>
                    </span>
                    <span class="text">3 month investment unit value</span>
                  </h2>
                </div>
              </div>
            </header>
            <div id="nav-history-render ">
              <div class="wrapper-table-scroll table-responsive">
                <table class="table table--fund table-striped table-hover fixed-columns responsive table-nomargin"
                  width="100%">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>NAV (USD/Unit)</th>
                      <th>Offer Price (USD/Unit)</th>
                      <th>Bid Price (USD/Unit)</th>
                      <th style="text-align: right; padding-right:15px;">Net Asset Value(USD)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of filterNavHistory">
                      <td class="text-center">{{item.FundPriceDate | date:'dd/MM/yyyy' }}</td>
                      <td class="text-center">{{item.NavPublish | number: '1.4-4'}}</td>
                      <td class="text-center">{{item.NavSub | number: '1.4-4'}}</td>
                      <td class="text-center">{{item.NavRed | number: '1.4-4'}}</td>
                      <td style="text-align: right; padding-right:15px;">{{item.NetAsset | number: '1.2-2'}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <footer class="text-center" style="margin-top: 40px;">
              <app-paginator [currentPage]="currentPage" [totalPage]="totalPageCount"
                (currentPageNumber)="setCurrentPage($event)"></app-paginator>
            </footer>
          </section>

          <section *ngIf="isDeviden" class="section-group section-table">
            <header style="margin-bottom: 20px">
              <div class="row">
                <div class="col-lg-7 col-xl-6">
                  <h2 class="topic-title">
                    <span rel="border-circle">
                      <i class="icon icon-devided"></i>
                    </span>
                    <span class="text">Historical Dividend Payment</span>
                  </h2>
                </div>
                <div class="col-lg-5 col-xl-6 -md">
                  <div class="group-botton text-right">
                    <a class="btn btn-primary -bg-white -download" (click)="exportFile('devidend')">Download </a>
                  </div>
                </div>
              </div>
            </header>
            <div id="nav-history-render">
              <div class="wrapper-table-scroll table-responsive">

                <table class="table table--fund table-striped table-hover fixed-columns responsive table-nomargin"
                  width="100%" id="devidend" style="display: none;">
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>FundCode</th>
                      <th>Dividend (THB/unit)</th>
                      <th>Book Closing Date</th>
                      <th>Payment Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of bind_data2">
                      <td class="text-center">{{item.No}}</td>
                      <td class="text-center">{{fundCode}}</td>
                      <td class="text-center">{{item.DivPerUnit | number: '1.4-4'}}</td>
                      <td class="text-center">{{item.ExDivDate | date:'dd/MM/yyyy'}}</td>
                      <td class="text-center" style="text-align: right; padding-right:15px;">
                        {{item.PaymentDate | date:'dd/MM/yyyy'}}</td>
                    </tr>
                  </tbody>
                </table>

                <table class="table table--fund table-striped table-hover fixed-columns responsive table-nomargin"
                  width="100%">
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Dividend (THB/unit)</th>
                      <th>Book Closing Date</th>
                      <th>Payment Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of filterDevidenHistory">
                      <td class="text-center">{{item.No}}</td>
                      <td class="text-center">{{item.DivPerUnit | number: '1.4-4'}}</td>
                      <td class="text-center">{{item.ExDivDate | date:'dd/MM/yyyy'}}</td>
                      <td class="text-center" style="text-align: right; padding-right:15px;">
                        {{item.PaymentDate | date:'dd/MM/yyyy'}}</td>
                    </tr>
                  </tbody>
                </table>

              </div>
            </div>
            <footer class="text-center" style="margin-top: 40px;">
              <app-paginator [currentPage]="devidendCurrentPage" [totalPage]="totalDevidendPageCount"
                (currentPageNumber)="setDevidendCurrentPage($event)" [isEn]="true"></app-paginator>
            </footer>
          </section>

          <section class="section-group section-cal">
            <div class="row">
              <!-- เครื่องคำนวณการลงทุน -->
              <div class="col-md-6">
                <section class="widget -cal -first">
                  <form action="" class="form -day">
                    <header>
                      <h3 class="topic-title">
                        <span rel="border-circle" style="margin-left: 0;">
                          <i class="icon icon-cal"></i>
                        </span>
                        <span class="text">Investment Calculation Tool</span>
                      </h3>
                      <p class="intro" style="margin-bottom: 0;">
                        Calculation Tool will help you calculate the money easily, quickly and comfortably
                      </p>
                    </header>

                    <div class="form-group">
                      <app-select [selectList]="selectListDropdown" defaultTitle="{{language.defaulttitle1}}" [isLight]="false"
                        [isRequire]="invalidPerfInvest" [enableSearch]="true" (fundId)="getFundIdFromSelect($event)">
                      </app-select>
                    </div>

                    <div class="form-group">
                      <app-datepicker [defaultPlaceholder]="language.defaulttitledate1" (pickDate)="getPickDate($event)" #datepick1
                        (blur)="setDate1(datepick1.value)"></app-datepicker>
                    </div>

                    <footer class="text-align -xs">
                      <app-button size="cal-full" text="{{language.defaulttitlebtn}}" (click)="clickCalculate('เครื่องคำนวณการลงทุน')">
                      </app-button>
                      <div id="btnPerformance-trigger" class="hidden" data-toggle="modal" data-target="#perforModal">
                      </div>
                    </footer>

                  </form>
                </section>
              </div>

              <!-- ผลการดำเนินงานกองทุน -->
              <div class="col-md-6">
                <section class="widget -cal -first -last">
                  <form action="" class="form -day">
                    <header>
                      <h3 class="topic-title">
                        <span rel="border-circle" style="margin-left: 0;">
                          <i class="icon icon-barchart-fund"></i>
                        </span>
                        <span class="text">Fund Performance</span>
                      </h3>
                      <p class="intro" style="margin-bottom: 0;">
                        Check performance of Fund Performance Here
                      </p>
                    </header>

                    <div class="form-group">
                      <app-select [selectList]="selectListDropdown" defaultTitle="{{language.defaulttitle1}}" [isLight]="false"
                        [isRequire]="invalidFundPerf" [enableSearch]="true" (fundId)="getFundIdFromSelect2($event)">
                      </app-select>
                    </div>

                    <div class="form-group">
                      <app-datepicker class="selectiongroup2" [defaultPlaceholder]="language.defaulttitledate2"
                        (pickDate)="getPickDate2($event)" #datepick2 (blur)="setDate2(datepick2.value)">
                      </app-datepicker>
                    </div>

                    <footer class="text-align -xs">
                      <app-button size="cal-full" text="{{language.defaulttitlebtn}}" (click)="clickCalculate2('ผลการดำเนินงานกองทุน')">
                      </app-button>
                      <div id="btnPerformance-trigger" class="hidden" data-toggle="modal" data-target="#perforModal">
                      </div>
                    </footer>

                  </form>
                </section>
              </div>
            </div>
          </section>
        </div>

      </div>

      <div *ngSwitchCase="'trade'" class="tab-pane fade show active" id="three" role="tabpanel"
        aria-labelledby="three-tab">
        <div class="container">

          <section class="section-group section-howto" style="padding-top: 0;">
            <header class="heading-title">
              <h2 class="topic-title">
                <span rel="border-circle">
                  <i class="icon icon-e-chart"></i>
                </span>
                <span class="text">Subscription and Redemption of Units</span>
              </h2>
            </header>

            <article>
              <ul class="list-unstyled list-bullet-number">
                <li>
                  <h5 class="f-semibold">
                    <span class="number">1</span>
                    <span class="text">For Participating Dealers</span>
                  </h5>
                  <div class="intro p-1">
                    <section class="section-info">
                      <h6 class="topic-title sub-title">Purchase of Units through the Participating Dealers</h6>
                      <p class="have-indent">You may subscribe for Units directly with the Management Company through a
                        Participating Dealer in Singapore including DBS Vickers Securities (Singapore) Pte Ltd and
                        Phillip Securities Pte Ltd.</p>
                      <p class="have-indent">You may approach a Participating Dealer to assist with your application to
                        the Management Company for subscription of Units (a “subscription order”). The Participating
                        Dealer may then apply to the Management Company for the subscription of Units.</p>
                      <p class="have-indent">Subscription orders for Units can be placed with the Management Company
                        during 9.00 a.m. – 2.00 p.m. (Thailand time) at the Sale Price on every Selling Date. If a
                        subscription order is received by the Management Company by 2.00 p.m. (Thailand time) on a
                        Selling Date, full payment of the subscription amount for the subscription order must be
                        received
                        by the Management Company in cleared funds by 11.00 a.m. (Thailand time) on the day falling 2
                        Weekdays after the Selling Date (or by such other time or within such other period as may from
                        time to time be determined by the Management Company in its absolute discretion).</p>
                      <p class="have-indent">If a subscription order is received by the Management Company after 2.00
                        p.m. (Thailand time) on a Selling Date, the subscription order shall be considered as having
                        been
                        made on the next following Selling Date at the Sale Price for that Selling Date. In such a case,
                        full payment of the subscription amount for the subscription order must be received by the
                        Management Company in cleared funds by 11.00 a.m. (Thailand time) on the day falling 2 Weekdays
                        after that Selling Date (or by such other time or within such other period as may from time to
                        time be determined by the Management Company in its absolute discretion).</p>
                      <p class="have-indent">The Sale Price of Units is based on forward pricing, which means that the
                        Sale Price of Units shall not be ascertainable at the time a subscription order is submitted to
                        a
                        Participating Dealer. If a subscription order is received by the Management Company by 2:00 p.m.
                        (Thailand time) on a Selling Date, the Sale Price of Units (in Baht) for that Selling Date will
                        be calculated by ascertaining the net asset value of the Fund as at the end of that Selling
                        Date.
                        The Sale Price of Units will then be converted from Baht to USD and published in USD, on the
                        next
                        Thai Business Day. If a subscription order is received after the stipulated cut-off time, the
                        subscription order will be treated as having been received before the stipulated cut-off time
                        for
                        the next following Selling Date.</p>
                      <p>For each subscription order, the minimum subscription is 20,000 Units and thereafter in
                        multiples of 100 Units.</p>
                      <p>If you wish to acquire less than the minimum subscription, you may only do so on the secondary
                        market.</p>
                      <p>You will have to pay subscription amounts by cash or such other methods as the Management
                        Company may from time to time decide.</p>
                      <p class="have-indent">Payments for Units subscribed shall be in US Dollars. The Fund Supervisor
                        (being a financial institution licensed to trade foreign currencies and convert the selling
                        price
                        of Units into US Dollars) shall apply the appropriate exchange rate and pay the subscription
                        amount into the Fund’s account in Baht. The Management Company shall not be responsible for any
                        exchange rate risk, such as margins or revenue deriving from currency exchange.</p>
                      <p class="have-indent">You should note that the subscription of Units through a Participating
                        Dealer is subject to the procedures prescribed by the Participating Dealer. You should therefore
                        consult the relevant Participating Dealer on the applicable subscription procedure, including
                        details on how Units are to be paid for, the cut-off time by which a subscription order must be
                        submitted to that Participating Dealer in order to be processed on a particular Selling Date and
                        the deadline by which you must make payment for your subscription order.</p>
                      <p class="have-indent">The following is a numerical example of the amount that you will have to
                        pay
                        based on a minimum subscription of 20,000 Units (please note that this may be subject to a
                        higher
                        minimum subscription amount imposed by the Participating Dealer) and a notional Sale Price
                        (inclusive of a subscription fee which is currently 1%) of USD 10*:</p>
                      <section class="section-units">
                        <ul class="list-unstyled list d-none d-sm-none d-md-block d-lg-block d-xl-block">
                          <li>
                            <div class="group">
                              <p class="units">
                                20,000
                                <small>Units</small>
                              </p>
                              <p>
                                <em>Number of Units to be subscribed</em>
                              </p>
                            </div>
                          </li>
                          <li>
                            <div class="group">
                              <p class="units"><small>USD</small> 10</p>
                              <p><em>Notional Sale Price <br>(includes 1% subscription fee)</em></p>
                            </div>
                          </li>
                          <li>
                            <div class="group">
                              <p class="units"><small>USD</small> 200,000</p>
                              <p><em>Subscription amount payable</em></p>
                            </div>
                          </li>
                        </ul>
                        <div class="d-block d-sm-block d-md-none d-lg-none d-lg none">
                          <div class="block-unit">
                            <p>20,000 <small>Units</small> <em> X </em> <small>USD</small> 10</p>
                            <p><em>= </em> <small>USD</small> 200,000</p>
                          </div>
                        </div>
                      </section>
                      <div class="note">
                        <p class="have-indent">*The notional Sale Price (which includes the applicable subscription fee)
                          used is for illustrative purposes only and is not to be construed as a forecast or indication
                          of any past or future performance of the Fund. The actual Sale Price of the Units will
                          fluctuate according to the Fund’s net asset value.</p>
                        <p class="have-indent">You should note that there may be additional fees and charges payable to
                          a
                          Participating Dealer (as may be determined by the Participating Dealer) for assistance with
                          the
                          subscription orders. The above numerical example has not included any such fees and charges.
                          You should therefore consult the relevant Participating Dealer for the actual amount of all
                          fees and charges that will be imposed by that Participating Dealer on your subscription order.
                        </p>
                        <p class="have-indent">You should note that the above example is purely hypothetical and is not
                          a
                          forecast or indication of any expectation of performance of the Fund.</p>
                      </div>
                    </section>
                    <section class="section-info">
                      <h6 class="topic-title sub-title">Sale of Units through the Participating Dealers</h6>
                      <p class="have-indent">You may redeem your Units with the Management Company through a
                        Participating Dealer including DBS Vickers Securities (Singapore) Pte Ltd and Phillip Securities
                        Pte Ltd.</p>
                      <p class="have-indent">You may approach a Participating Dealer to assist with your application to
                        the Management Company for redemption of Units (a “redemption order”). The Participating Dealer
                        may then apply to the Management Company for the redemption of Units.</p>
                      <p class="have-indent">Redemption orders can be placed with the Management Company on any
                        Redemption Date between 9.00 a.m. – 2.00 p.m. (Thailand time) at the Redemption Price.</p>
                      <p class="have-indent">Redemption orders made with the Management Company after 2.00 p.m.
                        (Thailand
                        time) on a Redemption Date shall be considered as having been placed on the next following
                        Redemption Date at the Redemption Price.</p>
                      <p class="have-indent">The Redemption Price of Units is based on forward pricing, which means that
                        the Redemption Price of Units shall not be ascertainable at the time the redemption order is
                        submitted to a Participating Dealer. If a redemption order is received by the Management Company
                        by the stipulated cut-off time of 2.00 p.m. (Thailand time) for a Redemption Date, the
                        Redemption
                        Price of Units will be calculated (in Baht) by ascertaining the net asset value of the Fund as
                        at
                        the end of that Redemption Date. The Redemption Price of Units will then be converted from Baht
                        to USD and published in USD, on the next Thai Business Day. If a redemption order is received
                        after the stipulated cut-off time, the redemption order will be treated as having been received
                        before the stipulated cut-off time for the next following Redemption Date.</p>
                      <p class="have-indent">You should note that the redemption of Units through a Participating Dealer
                        is subject to the procedures prescribed by the Participating Dealer. You should therefore
                        consult
                        the relevant Participating Dealer on the applicable redemption procedure, including details on
                        the cut-off time by which a redemption order must be submitted to that Participating Dealer in
                        order to be processed on a particular Redemption Date.</p>
                      <p class="have-indent">There is no minimum redemption order. Redemption shall be done in terms of
                        Units, and shall be subject to a minimum holding of 100 Units. If any redemption order causes
                        the
                        number of Units held in an account of a Unitholder to be less than 100 Units, the Management
                        Company reserves the right to redeem all of the Units held by such Unitholder.</p>
                      <p class="have-indent">Payments for Units redeemed shall be in US Dollars. The Fund Supervisor
                        (being a financial institution licensed to trade foreign currencies and convert the selling
                        price
                        of Units into US Dollars) shall apply the appropriate exchange rate in respect of the redemption
                        amount. The Management Company shall not be responsible for any exchange rate risk, such as
                        margins or revenue deriving from currency exchange.</p>
                      <p class="have-indent">Payment of redemption proceeds by the Fund would generally be within 7 Thai
                        Business Days from the date following the date the Redemption Price is calculated.
                        Notwithstanding the above, payment of the redemption proceeds to you will be made in such manner
                        as stipulated by the relevant Participating Dealer.</p>
                      <p class="have-indent">The following is a numerical example of how the amount to be paid to you on
                        a redemption order submitted to a Participating Dealer is calculated. This example assumes a
                        minimum redemption order of 1,000 Units (please note that this may be subject to a higher
                        minimum
                        redemption amount imposed by the Participating Dealer) and a notional Redemption Price
                        (inclusive
                        of a redemption charge which is currently waived) of USD 10*:</p>
                      <section class="section-units">
                        <ul class="list-unstyled list d-none d-sm-none d-md-block d-lg-block d-lg block">
                          <li>
                            <div class="group">
                              <p class="units">1,000 <small>Units</small></p>
                              <p><em>Number of Units to be subscribed</em></p>
                            </div>
                          </li>
                          <li>
                            <div class="group">
                              <p class="units"><small>USD</small> 10</p>
                              <p><em>Notional Sale Price <br>(includes 1% subscription fee)</em></p>
                            </div>
                          </li>
                          <li>
                            <div class="group">
                              <p class="units"><small>USD</small> 10,000</p>
                              <p><em>Subscription amount payable</em></p>
                            </div>
                          </li>
                        </ul>

                        <div class="d-block d-sm-block d-md-none d-lg-none d-lg none">
                          <div class="block-unit">
                            <p>1,000 <small>Units</small> <em> X </em> <small>USD</small> 10</p>
                            <p><em>= </em> <small>USD</small> 200,000</p>
                          </div>
                        </div>
                      </section>
                      <div class="note">
                        <p>*The notional Redemption Price (which includes the applicable redemption charge) used is for
                          illustrative purposes only and is not to be construed as a forecast or indication of any past
                          or future performance of the Fund. The actual Redemption Price of the Units will fluctuate
                          according to the Fund’s net asset value.</p>
                        <p>You should note that there may be additional fees and charges payable to a Participating
                          Dealer (as may be determined by the Participating Dealer) for assistance with the redemption
                          orders. The above numerical example has not included any such fees and charges. You should
                          therefore consult the relevant Participating Dealer for the actual amount of all fees and
                          charges that will be imposed by that Participating Dealer on your redemption order.</p>
                        <p>You should note that the above example is purely hypothetical and is not a forecast or
                          indication of any expectation of performance of the Fund.</p>
                      </div>
                    </section>
                  </div>
                </li>

                <li>
                  <h5 class="f-semibold">
                    <span class="number">2</span><span class="text">For Retail Invesots</span>
                  </h5>
                  <div class="intro p-1">
                    <section class="section-info">
                      <h6 class="topic-title sub-title">Purchase of Units via the SGX-ST</h6>
                      <p>You may buy Units via the SGX-ST using cash during normal trading hours on any Singapore Market
                        Day through brokers at market prices throughout the trading day for the SGX-ST.</p>
                      <p>Such purchase will be transacted on a willing buyer willing seller basis and will be subject to
                        such applicable market fees or charges and conditions, including but not limited to broker fees
                        and bid-ask condition.</p>
                      <p>Prices of Units bought or sold on the SGX-ST shall be based on their market prices throughout
                        the trading day for the SGX-ST. You should note that market prices for Units listed and traded
                        on
                        the SGX-ST may be different from their net asset value per Unit.</p>
                      <p>Units are quoted and traded on the SGX-ST in board lots of 100 Units.
                        If you wish to purchase Units on the SGX-ST, you must (if you have not already done so) open a
                        direct account with CDP or a sub-account with any CDP depository agent which may be a member
                        company of the SGX-ST, bank, merchant bank or trust company.</p>
                      <p>Also, units of the Fund will be listed, quoted and dealt in on the SGX-ST in US Dollar.</p>
                    </section>

                    <section class="section-info">
                      <h6 class="topic-title sub-title">Sale of Units via the SGX-ST</h6>
                      <p>Unitholders who had purchased their Units on the SGX-ST may dispose of such Units for cash on
                        the SGX-ST at market prices through brokers during normal trading hours on any Singapore Market
                        Day.</p>
                      <p>Such sale will be transacted on a willing buyer willing seller basis and will be subject to
                        such
                        applicable market fees or charges and conditions, including but not limited to broker fees and
                        bid-ask condition.</p>
                      <p>Prices of Units sold on the SGX-ST shall be based on their market prices throughout the trading
                        day for the SGX-ST. You should note that market prices for Units listed and traded on the SGX-ST
                        may be different from their net asset value per Unit.</p>
                      <p>Units of the Fund are quoted and traded on the SGX-ST in board lots of 100 Units.</p>
                      <p>You should note that Units purchased on the SGX-ST may not be redeemed with the Management
                        Company.</p>
                    </section>
                  </div>
                </li>
              </ul>
            </article>
          </section>

          <section class="section-group section-fee -dealing">
            <header class="heading-title">
              <h2 class="topic-title">
                <span rel="border-circle">
                  <i class="icon icon-cart-coin"></i>
                </span>
                <span class="text">Trading fees</span>
              </h2>
            </header>
            <div class="row">
              <div class="col-xl-6 group-list">
                <section>
                  <h3 class="h4 title">
                    <i class="icon icon-coin"></i>
                    <span class="text">
                      Fees and Charges payable by you if you invest in the Fund through the Participating Dealers
                      <small>
                        <br class="d-block d-sm-none">
                        (% of Unit price)</small>
                    </span>
                  </h3>

                  <ul class="list list-unstyled list-bullet-fee -usd">
                    <li>
                      <span>Subscription fee</span>
                      <span class="result">
                        <ul class="list-unstyled list-dash">
                          <li><u>For a subscription amount of USD 1 million or less</u><br>Currently: 1%; Maximum 2%
                          </li>
                          <li><u>For a subscription amount of more than USD 1 million</u><br>Currently: Waived; Maximum
                            2%</li>
                        </ul>
                      </span>
                    </li>
                    <li>
                      <span>Redemption fee</span>
                      <span class="result">
                        <em>Currently: Waived; Maximum 2%</em>
                      </span>
                    </li>
                    <li>
                      <span>Switching fee</span>
                      <span class="result">
                        <em>N.A.</em>
                      </span>
                    </li>
                  </ul>
                </section>
              </div>

              <div class="col-xl-6 group-list">
                <section>

                  <h3 class="h4 title">
                    <i class="icon icon-coin"></i>
                    <span class="text">
                      Fees and Charges payable by you if you invest in the Fund through the SGX-ST
                    </span>
                  </h3>

                  <ul class="list list-unstyled list-bullet-fee -usd">
                    <li>
                      <span>Clearing fee</span>
                      <span class="result">
                        Currently: 0.0325% of the contract value
                      </span>
                    </li>
                    <li>
                      <span>Trading fee</span>
                      <span class="result">
                        Currently: 0.0075% of the contract value
                      </span>
                    </li>
                    <li>
                      <span>Brokerage fee</span>
                      <span class="result">
                        Payable to stockbrokers as in the case of acquiring or selling shares or units listed on the
                        SGX-ST.
                        <br>
                        <br>
                        Please contact your stockbroker for further details.
                      </span>
                    </li>
                  </ul>
                </section>
              </div>
            </div>
          </section>

          <section class="section-group section-have-intro">
            <header>
              <h2 class="topic-title">
                <span rel="border-circle">
                  <i class="icon icon-cart-line"></i>
                </span>
                <span class="text">Trading Channels</span>
              </h2>
            </header>
            <div class="intro">
              <p class="font-24">You can trade funds through the following channels.</p>
            </div>
          </section>

          <section class="section-group section-dealer non-border">
            <header>
              <h2 class="topic-title h4">
                <span rel="border-circle" class="big-orange">
                  <i class="icon icon-headphone"></i>
                </span>
                <span class="text">
                  Participating Dealer
                </span>
              </h2>
            </header>
            <div class="section-sponsor -usd container">
              <ul class="list-sponsor list-unstyled row">
                <li class="col-12 col-sm-12 col-md-6">
                  <span class="info" data-mh="group-sponsor">
                    <span class="text h6">DBS Vickers Securities (Singapore) Pte Ltd.</span>
                    <span class="number address">Address : <em>12 Marina Boulevard #10-01 Marina Bay Financial Centre
                        Tower 3 Singapore 018982</em></span>
                  </span>
                </li>
                <li class="col-12 col-sm-12 col-md-6">
                  <span class="info" data-mh="group-sponsor">
                    <span class="text h6">Phillip Securities Pte Ltd.</span>
                    <span class="number address">Address : <em>250 North Bridge Road, Raffles City Tower #06-00
                        Singapore
                        1791010</em>
                      <br>Customer Service Hotline : <em>6531 1555</em>
                      <br>Email : <a
                        href="mailto=&quot;talktophillip@phillip.com.sg&quot;">talktophillip@phillip.com.sg</a></span>
                  </span>
                </li>
              </ul>
            </div>
          </section>
        </div>

      </div>

      <div *ngSwitchCase="'report'" class="tab-pane fade show active" id="four" role="tabpanel"
        aria-labelledby="four-tab">
        <div class="container">

          <section class="section-group non-border section-usd-price">
            <header class="heading-title">
              <h2 class="topic-title">
                <span rel="border-circle">
                  <i class="icon icon-price"></i>
                </span>
                <span class="text">Price</span>
              </h2>
              <a href="http://sgx.com/wps/portal/sgxweb/home/company_disclosure/all_in_one/others/!ut/p/a1/04_Sj9CPykssy0xPLMnMz0vMAfGjzOKNHB1NPAycDSwNLNwtDDxdw8J8Xdw8DC0CDYAKIpEVWBi5mxt4GpoFOhuGOBs7GxqQqN8_1BCoP9Qp0MQpLNTQ29GEOP0GOIAjQfvD9aNQlWDxAaoCLE5EUxBmAFLg7xQcHBZmGOhqDFWAx5GRQF-Y47LC2clcvyA3NDTCINNTN1BREQCMSasC/dl5/d5/L2dBISEvZ0FBIS9nQSEh/pw/Z7_2AA4H0C09OU170IUBQ4BVU1CB7/act/id=0/373920610429/=/"
                class="link-orange" target="_blank">
                <span class="text">View all</span>
                <i class="icon icon-swiper-right"></i>
              </a>
            </header>
          </section>

          <section class="section-group non-border section-pdf-report">
            <header class="heading-title">
              <h2 class="topic-title">
                <span rel="border-circle">
                  <i class="icon icon-data"></i>
                </span>
                <span class="text">PDF Report</span>
              </h2>
              <a href="https://www.stoxx.com/index-details?symbol=SXAE3DGV&stoxxindex=sxae3dgv&searchTerm=STOXX%C2%AE+ASEAN+Select+Dividend+30"
                class="link-orange" target="_blank">
                <span class="text">View all</span>
                <i class="icon icon-swiper-right"></i>
              </a>
            </header>
          </section>
        </div>
      </div>

    </div>


  </div>
</section>

<ngx-ui-loader></ngx-ui-loader>

<!-- perModal -->
<div class="modal fade" id="perModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-card--container">
        <button type="button" class="close--button close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">
            <i class="fas fa-times"></i>
          </span>
        </button>
        <h4 class="modal-title" id="calModalLabel">
          <div class="border-circle">
            <img src="assets/images/icon/ic-barchart-blue@2x.png" alt="icon" />
          </div>
          <span class="text">Performance Report</span>
        </h4>
        <div class="modal--body">
          <table class="table table--fund -credit table-striped table-hover">
            <thead>
              <tr>
                <th width="10%">NO.</th>
                <th width="50%" class="text-left">Portfolio</th>
                <th width="40%">{{investPeriod}}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1.</td>
                <td class="text-left">{{investPortfolioCode}}</td>
                <td>{{investBenchmark}}%</td>
              </tr>
              <tr>
                <td>2.</td>
                <td class="text-left">{{investSd}}</td>
                <td>{{investSDBenchmark}}%</td>
              </tr>
              <tr *ngFor="let dpr of dataPerformanceReports">
                <td>{{dpr['index']}}.</td>
                <td class="text-left">{{dpr['value']}}</td>
                <td>{{dpr['percent']}}%</td>
              </tr>
            </tbody>
          </table>
          <section class="footer-remark">
            <header>
              <h5 class="topic-title">Note</h5>
            </header>

            <div class="info">
              <p *ngFor="let item of investNoteTitle">{{item['index']}}. <span>{{item['noteTitle']}}</span>
                <br>
                {{item['noteDetail']}} </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- sumModal -->
<div class="modal fade" id="sumModal" tabindex="-1" role="dialog" aria-labelledby="perforModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-card--container">
        <button type="button" class="close--button close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">
            <i class="fas fa-times"></i>
          </span>
        </button>
        <h4 class="modal-title" id="calModalLabel">
          <div class="border-circle">
            <img src="assets/images/icon/ic-cal-blue@2x.png" alt="icon" />
          </div>
          <span class="text">Performance Calculation</span>
        </h4>
        <div class="modal--body">
          <section class="wrapper-modal">
            <!-- table 1 -->
            <section class="group-table">
              <table class="table table--fund -credit table-striped table-hover">
                <thead>
                  <tr>
                    <th>NO.</th>
                    <th class="text-left">Portfolio</th>
                    <th>YTD</th>
                    <th>3M</th>
                    <th>6M</th>
                    <th>1Y</th>
                    <th>3Y</th>
                    <th>5Y</th>
                    <th>10Y</th>
                    <th>Since <br> Inception</th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td>1</td>
                    <td class="text-left">{{portPerformance[0]}}</td>
                    <td>{{portPerformance[1]}}%</td>
                    <td>{{portPerformance[2]}}%</td>
                    <td>{{portPerformance[3]}}%</td>
                    <td>{{portPerformance[4]}}%</td>
                    <td>{{portPerformance[5]}}%</td>
                    <td>{{portPerformance[6]}}%</td>
                    <td>{{portPerformance[7]}}%</td>
                    <td>{{portPerformance[8]}}%</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td class="text-left">{{portSDPerformance[0]}}</td>
                    <td>{{portSDPerformance[1]}}%</td>
                    <td>{{portSDPerformance[2]}}%</td>
                    <td>{{portSDPerformance[3]}}%</td>
                    <td>{{portSDPerformance[4]}}%</td>
                    <td>{{portSDPerformance[5]}}%</td>
                    <td>{{portSDPerformance[6]}}%</td>
                    <td>{{portSDPerformance[7]}}%</td>
                    <td>{{portSDPerformance[8]}}%</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td class="text-left">{{portBenchmarkPerformance[0]}}</td>
                    <td>{{portBenchmarkPerformance[1]}}%</td>
                    <td>{{portBenchmarkPerformance[2]}}%</td>
                    <td>{{portBenchmarkPerformance[3]}}%</td>
                    <td>{{portBenchmarkPerformance[4]}}%</td>
                    <td>{{portBenchmarkPerformance[5]}}%</td>
                    <td>{{portBenchmarkPerformance[6]}}%</td>
                    <td>{{portBenchmarkPerformance[7]}}%</td>
                    <td>{{portBenchmarkPerformance[8]}}%</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td class="text-left">{{portSDBenchmarkPerformance[0]}}</td>
                    <td>{{portSDBenchmarkPerformance[1]}}%</td>
                    <td>{{portSDBenchmarkPerformance[2]}}%</td>
                    <td>{{portSDBenchmarkPerformance[3]}}%</td>
                    <td>{{portSDBenchmarkPerformance[4]}}%</td>
                    <td>{{portSDBenchmarkPerformance[5]}}%</td>
                    <td>{{portSDBenchmarkPerformance[6]}}%</td>
                    <td>{{portSDBenchmarkPerformance[7]}}%</td>
                    <td>{{portSDBenchmarkPerformance[8]}}%</td>
                  </tr>
                </tbody>
              </table>
              <section class="footer-remark">
                <header>
                  <h5 class="topic-title">Note</h5>
                </header>

                <div class="info">
                  <p *ngFor="let item of portPerfNote">{{item['index']}}. {{item['noteTitle']}}<br>
                    {{item['noteDetail']}} </p>
                </div>
              </section>
            </section>

            <!-- table 2 -->
            <section class="group-table" style="margin-top: 40px;">
              <table class="table table--fund -credit table-striped table-hover">
                <thead>
                  <tr>
                    <th class="text-left">ปี</th>
                    <th>{{returnPerfYear[0]}}</th>
                    <th>{{returnPerfYear[1]}}</th>
                    <th>{{returnPerfYear[2]}}</th>
                    <th>{{returnPerfYear[3]}}</th>
                    <th>{{returnPerfYear[4]}}</th>
                    <th>{{returnPerfYear[5]}}</th>
                    <th>{{returnPerfYear[6]}}</th>
                    <th>{{returnPerfYear[7]}}</th>
                    <th>{{returnPerfYear[8]}}</th>
                    <th>{{returnPerfYear[9]}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="text-left">{{returnPortPerf[0]}}</td>
                    <td>{{returnPortPerf[1]}}%</td>
                    <td>{{returnPortPerf[2]}}%</td>
                    <td>{{returnPortPerf[3]}}%</td>
                    <td>{{returnPortPerf[4]}}%</td>
                    <td>{{returnPortPerf[5]}}%</td>
                    <td>{{returnPortPerf[6]}}%</td>
                    <td>{{returnPortPerf[7]}}%</td>
                    <td>{{returnPortPerf[8]}}%</td>
                    <td>{{returnPortPerf[9]}}%</td>
                    <td>{{returnPortPerf[10]}}%</td>
                  </tr>
                  <tr>
                    <td class="text-left">{{returnPortSDPerf[0]}}</td>
                    <td>{{returnPortSDPerf[1]}}%</td>
                    <td>{{returnPortSDPerf[2]}}%</td>
                    <td>{{returnPortSDPerf[3]}}%</td>
                    <td>{{returnPortSDPerf[4]}}%</td>
                    <td>{{returnPortSDPerf[5]}}%</td>
                    <td>{{returnPortSDPerf[6]}}%</td>
                    <td>{{returnPortSDPerf[7]}}%</td>
                    <td>{{returnPortSDPerf[8]}}%</td>
                    <td>{{returnPortSDPerf[9]}}%</td>
                    <td>{{returnPortSDPerf[10]}}%</td>
                  </tr>
                  <tr>
                    <td class="text-left">{{returnPortBenchmark[0]}}</td>
                    <td>{{returnPortBenchmark[1]}}%</td>
                    <td>{{returnPortBenchmark[2]}}%</td>
                    <td>{{returnPortBenchmark[3]}}%</td>
                    <td>{{returnPortBenchmark[4]}}%</td>
                    <td>{{returnPortBenchmark[5]}}%</td>
                    <td>{{returnPortBenchmark[6]}}%</td>
                    <td>{{returnPortBenchmark[7]}}%</td>
                    <td>{{returnPortBenchmark[8]}}%</td>
                    <td>{{returnPortBenchmark[9]}}%</td>
                    <td>{{returnPortBenchmark[10]}}%</td>
                  </tr>
                  <tr>
                    <td class="text-left">{{returnPortSDBenchmark[0]}}</td>
                    <td>{{returnPortSDBenchmark[1]}}%</td>
                    <td>{{returnPortSDBenchmark[2]}}%</td>
                    <td>{{returnPortSDBenchmark[3]}}%</td>
                    <td>{{returnPortSDBenchmark[4]}}%</td>
                    <td>{{returnPortSDBenchmark[5]}}%</td>
                    <td>{{returnPortSDBenchmark[6]}}%</td>
                    <td>{{returnPortSDBenchmark[7]}}%</td>
                    <td>{{returnPortSDBenchmark[8]}}%</td>
                    <td>{{returnPortSDBenchmark[9]}}%</td>
                    <td>{{returnPortSDBenchmark[10]}}%</td>
                  </tr>
                </tbody>
              </table>
              <section class="footer-remark">
                <header>
                  <h5 class="topic-title">{{language.funddetailthsummodal1}}</h5>
                </header>
                <div class="info">
                  <ol class="list-number">
                    <li>{{language.funddetailthsummodal2}}</li>
                    <li>{{language.funddetailthsummodal3}}</li>
                    <li>
                      <span
                        class="text-danger">{{language.funddetailthsummodal4}}</span>
                    </li>
                    <li>{{language.funddetailthsummodal5}}</li>
                    <li>{{language.funddetailthsummodal6}}</li>
                    <li>{{language.funddetailthsummodal7}}</li>
                    <li>{{language.funddetailthsummodal8}}</li>
                  </ol>
                </div>
              </section>
            </section>
          </section>
        </div>
      </div>
    </div>
  </div>
</div>
<ngx-ui-loader></ngx-ui-loader>